// ** Icons Import
import {Circle, Monitor} from 'react-feather'

export default [
    {
        id: 'sites',
        title: 'Сайты',
        icon: <Monitor size={18} />,
        //badge: 'light-warning',
        //badgeText: '2',
        children: [
            {
                id: 'sites_list',
                title: 'Список сайтов',
                icon: <Circle size={6} />,
                navLink: '/sites/'
            },
            {
                id: 'site_balance',
                title: 'Журнал баланса',
                icon: <Circle size={6} />,
                navLink: '/sites/site-balances/'
            }
        ]
    }
]
